// hooks/useApi.js
import { useCallback, useState } from 'react';

// Get token from environment variable (build-time) or a constant
import { useSession } from "../components/SessionProvider";

// hooks/useApi.js
export const useApi = () => {
    const apiUrl = import.meta.env.VITE_API_URL_MAIN;
    const { userLogin } = useSession();
    const token = userLogin.session_token;

    const apiCall = useCallback(async (command, options = {}) => {
        const {
            method = 'GET',
            params = {},
            body = null,
            headers = {},
        } = options;

        const urlParams = new URLSearchParams({ command, ...params });
        const url = `${apiUrl}${urlParams.toString()}`;

        const fetchOptions = {
            method,
            credentials: 'include',
            headers: {
                'X-API-TOKEN': token,
                'X-API-EMAIL': userLogin.user_email ?? '',
                ...headers,
            },
        };

        if (body && ['POST', 'PUT', 'PATCH'].includes(method)) {
            if (body instanceof FormData) {
                // Do NOT set Content-Type for FormData
                fetchOptions.body = body;
            } else {
                fetchOptions.headers['Content-Type'] = 'application/json';
                fetchOptions.body = JSON.stringify(body);
            }
        }

        const response = await fetch(url, fetchOptions);

        if (!response.ok) {
            throw new Error(`API error: ${response.status}`);
        }

        return response;
    }, [apiUrl, token, userLogin.user_email]);

    return { apiCall };
}